import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddStaffComponent } from '../add-staff/add-staff.component';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
@Component({
  selector: 'app-mystaff',
  templateUrl: './mystaff.component.html',
  styleUrls: ['./mystaff.component.css']
})
export class MystaffComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  allStaffRecords: any[] = [];
  paginatedRecords: any[] = [];
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  childData: any
  type: any;
  pageSize = 5;
  pageIndex = 0;
  totalRecords = 0;
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.getStaff();
    // alert("type in myyyy"+this.lookupModel.getLoggedUser().type)
  }
  getStaff(): void {
    const type = this.lookupModel.getLoggedUser().type && this.lookupModel.getLoggedUser().type === 'franchise' ? 'staff' : 'substaff'
    this.rsbService.getStaffData(type, this.pageSize, this.pageIndex).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents.items
        this.totalRecords = rsp.contents.total;
        this.updatePaginatedRecords();
      }
    })

  }

  confirmBlock(records: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you really want to block this user?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Block',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.blockUser(records).subscribe((success) => {
          if (success) {
            Swal.fire('Blocked!', 'The user has been blocked.', 'success');
            this.getStaff(); // refresh UI if needed
          } else {
            Swal.fire('Error', 'Failed to block the user.', 'error');
          }
        })
      }
    })
  }

  blockUser(records: any): Observable<boolean> {
    return this.rsbService.blockUser(records.franchiseId).pipe(
      map((rsp: any) => rsp.statusCode === 0), // return true if success, else false
      catchError(() => of(false)) // handle errors gracefully
    );
  }

  confirmUnblock(records) {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to unblock this user?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Unblock',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.unBlockUser(records).subscribe((success) => {
          if (success) {
            this.getStaff();
            Swal.fire('Un Blocked !!', 'The user has been  unblocked.', 'success');
             // refresh UI if needed
          } else {
            Swal.fire('Error', 'Failed to block the user.', 'error');
          }
        })
      }
    
    });
  }

  unBlockUser(records: any): Observable<boolean> {
    return this.rsbService.unBlockUser(records.franchiseId).pipe(
      map((rsp: any) => rsp.statusCode === 0), // return true if success, else false
      catchError(() => of(false)) // handle errors gracefully
    );
  }
  updatePaginatedRecords() {
    this.paginatedRecords = this.allStaffRecords;
  }
  addStaff(): void {
    const modalRef = this.modalService.open(AddStaffComponent);

    modalRef.result.then((result) => {
      const rslt = result;
      this.type = rslt.type;
      const arg = {
        name: rslt.name,
        email: rslt.email,
        mobile: rslt.mobile,
        city: rslt.city,
        district: rslt.district,
        type: this.lookupModel.getLoggedUser().type && this.lookupModel.getLoggedUser().type === 'franchise' ? 'staff' : 'substaff',
        franchiseId: this.lookupModel.getLoggedUser().franchiseId
      }
      this.rsbService.addMyStaff(arg).subscribe((rsp) => {
        if (rsp && rsp.statusCode === 0) {
          this.getStaff();

        }
      })
    }, (reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  toggleRow(index: number) {
    const franchiseId = this.allStaffRecords[index].franchiseId;
    this.rsbService.getStaffLogs({ franchiseId: franchiseId }).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.childData = rsp.contents
        this.expandedIndex = this.expandedIndex === index ? null : index;
      }
    })

  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    alert(this.pageIndex)
    this.getStaff()
  }

}


